import React, { useEffect, useState } from "react";
import ViewTable from "../../../components/tables/viewTable";
import dayjs from "dayjs";
import { PaymentType } from "../../../types/paymentTypes";

type PropsType = {
  tableData: PaymentType[];
};

const AllPaymentTable = (props: PropsType) => {
  const { tableData } = props;
  const [modifiedTableData, setmodifiedTableData] = useState<PaymentType[]>([]);

  const columns = [
    { header: "Received Date", accessor: "receivedDate" },
    {
      header: "Amount",
      accessor: "amount",
      cell: (row: any) => `${Number(row?.amount).formatRupee()}`,
    },
    { header: "Company Name", accessor: "companyName" },
    { header: "Transaction Details", accessor: "txnDetails" },
  ];

  useEffect(() => {
    if (tableData?.length < 1) return;
    let _dataIs: any = [];
    for (let i = 0; i < tableData.length; i++) {
      const e: PaymentType = tableData[i];
      const _admin = {
        amount: e.amount,
        companyName: e.company?.companyName,
        receivedDate: !dayjs(e.receivedDate).isValid()
          ? "NA"
          : dayjs(e.receivedDate).format("MMM DD, YYYY"),
        txnDetails: e.txnDetails,
      };
      _dataIs.push(_admin);
    }
    setmodifiedTableData(_dataIs);
  }, [tableData]);

  return (
    <div>
      <ViewTable
        pagination={modifiedTableData?.length > 5}
        columns={columns}
        data={modifiedTableData}
      />
    </div>
  );
};

export default AllPaymentTable;
